import { useState } from "react";

const scaleToTopPositionMapping = {
  2.5: -5,
  2: -5,
  1.75: -5,
  1.5: -5,
  1.25: -5,
  1.1: -6,
  1: -6,
  0.9: -5,
  0.8: -5,
  0.75: -5,
  0.67: -4,
  0.5: -5,
  0.33: -5,
  0.25: -5,
};

function useContentCompanyWebLogoResizer() {
  const [scale, setScale] = useState(window.devicePixelRatio);
  const roundedScale = Math.round(scale * 100) / 100;
  const top = scaleToTopPositionMapping[roundedScale];
  const logoTriangleStyle = {
    top,
  };

  window.onresize = () => {
    setScale(window.devicePixelRatio);
  };

  return { logoTriangleStyle };
}

export default useContentCompanyWebLogoResizer;
